<template>
  <el-container class="login-body">
    <el-container class="info-section el-col-12">
      <div class="panel">
        <h1>The Future of<br>Stock Surveillance</h1>
        <div>
          Sequire unlocks stock buyers' behaviors and trends for issuers
          of publicly traded companies
        </div>
        <div class="learn-more">
          <el-button type="text" v-track="{ event: 'login_learn' }">
            <a href="https://mysequire.com/" target="_blank">LEARN MORE</a>
          </el-button>
        </div>
      </div>
      <el-footer class="powered-by">Powered by SRAX.</el-footer>
    </el-container>
    <div class="form-section el-col-12">
      <div class="panel">
        <div class="content-img">
          <img :src="getLogo" alt="">
        </div>
        <div class="blue-title">Welcome back!</div>
        <div class="subtitle">Please provide your login information.</div>
        <div class="blue-bit"></div>
        <div class="login-form">
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            :rules="rules"
            @submit.native.prevent
            @keyup.enter.native="validateBeforeSubmit('ruleForm')"
            :disabled="isSending"
            size="medium"
          >
            <el-form-item label="Email" prop="email">
              <el-input
                @input="onInputChange"
                type="email"
                v-model="ruleForm.email"
                id="email"
                class="blue-input"
              />
            </el-form-item>

            <el-form-item label="Password" prop="password">
              <el-input
                class="login-pass blue-input"
                type="password"
                v-model="ruleForm.password"
                id="password"
              >
                <div slot="suffix">
                  <router-link
                    to="/passwordRecovery"
                    class="password-recovery"
                    v-track="{ event: 'login_forgot' }"
                  >
                    Forgot?
                  </router-link>
                </div>
              </el-input>
            </el-form-item>
          </el-form>
          <el-button
            type="primary"
            class="btn-block"
            @click="validateBeforeSubmit('ruleForm')"
            :disabled="isSending"
            size="medium"
            v-track="{ event: 'login_enter' }"
          >
            {{ form.login }}
          </el-button>
          <div class="create-account">
            or <router-link class="underline" to="/signup" v-track="{ event: 'login_create' }">
              create an account
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import { mapState } from 'vuex';
import { getBrand } from '@/whitelabel.config';
import EventBus from '@/eventBus';

export default {
  name: 'Login',
  data() {
    return {
      isSending: false,
      brand: getBrand(),
      ruleForm: {
        email: '',
        password: '',
      },
      form: {
        login: 'Login to your account',
      },
      rules: {
        email: [
          {
            required: true,
            message: 'The email field is required.',
            trigger: 'blur',
          },
          {
            type: 'email',
            message: 'The email field must be a valid email.',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: 'The password field is required.',
            trigger: 'blur',
          },
          {
            min: 6,
            message: 'The password field must be at least 6 characters.',
            trigger: 'blur, change',
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      isDark: (state) => state.layout.isDark,
    }),
    auth() {
      return this.$store.state.auth;
    },
    views() {
      return this.$store.state.views;
    },
    getLogo() {
      if (this.isDark && Object.prototype.hasOwnProperty.call(this.brand.logoList, 'loginDark')) return this.brand.logoList.loginDark;
      return this.brand.logoList.login;
    },
  },
  methods: {
    onInputChange() {
      this.ruleForm.email = this.ruleForm.email.toLowerCase().trim();
    },
    validateBeforeSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;

        this.formSubmit();
      });
    },
    async formSubmit() {
      const { dispatch, commit } = this.$store;
      const { email, password } = this.ruleForm;
      this.form.login = ' Processing ...';
      this.isSending = true;
      const response = await dispatch('auth/login', { email, password });

      if (this.auth.LOGIN_SUCCESS) {
        commit('user/update', response);
        const prev = this.views.preview.substring(1);
        const isValidRoute = this.$router
          .options
          .routes[0]
          .children
          .filter((r) => r.path === prev).length > 0;

        const route = isValidRoute ? prev : '/';
        EventBus.$emit('setToken', this.auth.access_token);
        await this.$router.push(route);
      }
      this.form.login = 'Login to your account';
      this.isSending = false;
    },
  },
  beforeMount() {
    const html = document.getElementById('html-base');

    if (this.$store.state.layout.isDark) html.classList.add('dark');
    else html.classList.remove('dark');
  },
};
</script>

<style scoped lang="scss">
  @import "~@/styles/variables.scss";
  @import "~@/styles/login.scss";
</style>
